import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";

const Data = [
  {
    id: 1,
    name: 'Warehouse Stores',
    icon: 'warehouse/warehouse_3.png',
    backgroundColor: '#1F78D9',
    tintColor: null,
    navigation: '/WarehouseConfigStores',
  },
  {
    id: 2,
    name: 'Warehouse Users',
    icon: 'warehouse/entrepreneur.png',
    backgroundColor: '#AD39BF',
    tintColor: null,
    navigation: '/WarehouseConfigUsers',
  },
  {
    id: 3,
    name: 'Warehouse Process Stage',
    icon: 'images/app-development.png',
    backgroundColor: '#1F78D9',
    tintColor: null,
    navigation: '/WarehouseProcessStageList',
  },
  {
    id: 4,
    name: 'Warehouse Process Stage User',
    icon: 'warehouse/warehouse_5.png',
    backgroundColor: '#AD39BF',
    tintColor: null,
    navigation: '/WarehouseProcessStageUsers',
  },
];
  

const WarehouseConfigList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id,enabledGarmentProcessStage, enabledGarmentProcessStageBrand } = location.state || {}; // Fallback to prevent undefined errors

  const filteredData =
    enabledGarmentProcessStageBrand && enabledGarmentProcessStage
      ? Data
      : Data.filter(item => item.id !== 3 && item.id !== 4); 

      const [visible, setVisible] = useState(false);


  const renderCardItem = () => {
    return filteredData?.map((item, index) => {
      return (
        <div
           onClick={() =>
                    navigate(item.navigation, {
                      state: {
                        id: id,
                      },
                    })
                  }
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-1 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 45,
                width: 45,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };
 
  
  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/WarehouseManagementList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">Warehouse Configuration</p>
            </div>
          </div>

           

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-3">
          {filteredData?.length ? (
          renderCardItem()
        ) : (
          <p>No card data available.</p>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              // width: 100,
              // height: 50,
              alignSelf: "center",
            }}
          />
        </div>
         
      </div>
       
        <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default WarehouseConfigList;
